<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <agent-field v-model="form.main.ac_agentname" @select="onSelectAgent" />
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >保存</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import AgentField from "@/components/field/AgentField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    AgentField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/agent/agentcust",
      codeField: "ac_code",
      statusField: "ac_statuscode",
      caller: "AgentCust",
      xtype: "agent-agentcust-formpanel",
      form: {
        main: {},
      }
    };
  },
  methods: {
    onSelectAgent(selection) {
      var me = this,
        main = me.form.main;
      main.ac_agentname = selection.cu_name;
      main.ac_agentid = selection.id;
      main.ac_agentcode = selection.cu_code;
    },
    save() {
      var me = this,
        main = me.form.main;
      me.$loading({
        url: '/api/agent/agentcust/change',
        method: 'POST',
        jsonData: {
          ac_agentcode: main.ac_agentcode,
          ac_agentid: main.ac_agentid,
          ac_agentname: main.ac_agentname,
          id: main.id
        }
      }).then(function(res) {
        if(res.success) {
          me.preLaunchProcess(res.data)
        }
        else {
          me.$weui.topTips(res.message, 3000);
        }
      })
    },
    preLaunchProcess(data) {
      var me = this;
      me.$loading({
          method: "post",
          url: "/api/process/instance/pre_launch",
          jsonData: {
              bizType: data.change.name,
              bizId: data.change.id,
              bizCode: data.change.code,
              viewType: me.xtype
          }
      }).then(function (res) {
          if (res.success) {
            me.selectNodeHandler(res.data.items, function (selectedUserMap) {
              me.launchProcess(data, selectedUserMap);
            });
          } else {
              me.$weui.topTips(res.message, 3000);
          }
      });
    },
    launchProcess(data, selectedUserMap) {
      var me = this;
      me.$loading({
        method: "post",
        url: '/api/process/instance/launch',
        jsonData: {
          bizType: data.change.name,
          bizId: data.change.id,
          bizCode: data.change.code,
          viewType: me.xtype,
          selectedUserMap
        }
      }).then(function (res) {
        if (res.success) {
          me.$router.back()
        }
      }).catch(function () {
          me.$weui.topTips("变更失败", 3000);
      });
    },
  }
}
</script>